import React from "react";
import "./CarouselBS.css";

export const CarouselItemBS = ({ item, width }) => {
  const imageStyle = {
    backgroundImage: `url(${item.icon})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  };

  return (
    <div className="carousel-itembs" style={{ width: width }}>
      <div className="carousel-img-containerbs" style={imageStyle}>
        <div className="carousel-title">{item.title}</div>
      </div>
    </div>
  );
};

export default CarouselItemBS;
